export default __webpack_public_path__ + "static/media/complementary--carts--g1.fea12c17.png";